import React from 'react';
import { CardContent, Slider, styled, SxProps, Theme, Typography } from '@mui/material';

const defaultStyles = {
    root: {
        minWidth: theme => theme.spacing(50),
    } as SxProps<Theme>,
    minmax: {
        marginLeft: theme => theme.spacing(1),
        marginRight: theme => theme.spacing(1),
    } as SxProps<Theme>,
};

const Horizontal = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'space-between'
});

export type AccelCapStyles = typeof defaultStyles;

export type AccelCapProps = {
    caption?: string;
    accelCap: number;
    onAccelCap: (accelCap: number) => void;
    styles?: AccelCapStyles;
}

export function AccelCap(props: AccelCapProps) {
    const {
        caption = 'Acceleration Cap',
        accelCap, onAccelCap,
        styles = defaultStyles
    } = props;

    return (
        <CardContent sx={styles.root}>
            <Typography >{caption}: {accelCap}</Typography>
            <Horizontal>
                <Typography sx={styles.minmax}>0.0</Typography>
                <Slider
                    min={0.0} max={1.0} step={0.01}
                    value={accelCap} onChange={(_, value) => onAccelCap(value as number)}
                />
                <Typography sx={styles.minmax}>1.0</Typography>
            </Horizontal>
        </CardContent>
    );
}
